import React from 'react';
import { createUseStyles } from 'react-jss';
import { useMenuContext } from './MenuContext';
import { Colours } from '../../tokens';
import classNames from 'classnames';
const useStyles = createUseStyles({
    menuList: {
        position: 'absolute',
        borderRadius: 3,
        backgroundColor: 'white',
        boxShadow: `3px 0 15px ${Colours.quarternary}, 0 3px 15px ${Colours.quarternary}`,
        overflow: 'hidden',
    },
    right: {
        left: 0,
    },
    left: {
        right: 0,
    },
});
function MenuList({ children, position = 'right', }) {
    const classes = useStyles();
    const [isShown] = useMenuContext();
    if (!isShown) {
        return null;
    }
    return (React.createElement("ul", { className: classNames(classes.menuList, classes[position]) }, children));
}
export default MenuList;
//# sourceMappingURL=MenuList.js.map